import * as customerInfoActions from 'app/core/store/customer-info/customer-info.actions';
import { Definition } from 'app/core/store/definitions/definition.interface';
import * as actions from 'app/core/store/session/selected-customer/select-customer.actions';
import { LoadState, LoadStateInitialValue } from 'app/core/interfaces/generic.interface';

const INITIAL_STATE = new LoadStateInitialValue<Definition>();

export function reducer(state = INITIAL_STATE, action: actions.Actions | customerInfoActions.Actions): LoadState<Definition> {
  switch (action.type) {
    case actions.SET_SELECTED_CUSTOMER:
      return {
        ...INITIAL_STATE,
        data: action.payload.customer,
        loadSuccess: true,
      };
    case actions.CLEAR_SELECTED_CUSTOMER:
      return { ...INITIAL_STATE, loadSuccess: true };
    case customerInfoActions.CUSTOMER_INFO_LOAD_SUCCESS:
      /*
            return {
              id:action.payload.customerInfo,
              name: null,
            }
      */
      // debugger; // TODO 452
      return state;
    default:
      return state;
  }
}
